module.exports = __webpack_public_path__ + "img/shogi_2021_pack_4_0003.90a519cf.png";